import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import path from 'path';
import { mapGetters } from 'vuex';
import Logo from './Logo';
import SidebarItem from './SidebarItem';
function flattenSidebarRoutes(routes) {
  var parentPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!routes || !routes.length) return [];
  var res = [];
  var base = parentPath || '/';
  routes.forEach(function (route) {
    if (route.hidden) {
      if (route.children && route.children.length) {
        var nextBase = route.path === '/' || route.path === '' ? base : path.resolve(base, route.path);
        res.push.apply(res, _toConsumableArray(flattenSidebarRoutes(route.children, nextBase)));
      }
    } else {
      if (parentPath) {
        res.push(_objectSpread(_objectSpread({}, route), {}, {
          _sidebarParentPath: parentPath
        }));
      } else {
        res.push(route);
      }
    }
  });
  return res;
}
export default {
  name: 'AppSidebar',
  components: {
    SidebarItem: SidebarItem,
    Logo: Logo
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['sidebar'])), {}, {
    sidebarRoutes: function sidebarRoutes() {
      var raw = this.$store.getters['router/asyncRouters'] || [];
      return flattenSidebarRoutes(raw);
    },
    showLogo: function showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    }
  })
};